// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.general.location.device.AdminUpdatePracticeLocationSerialDeviceRequest */
/* istanbul ignore next */
@GandalfModel
export class AdminUpdatePracticeLocationSerialDeviceRequest extends GandalfModelBase {

	@GandalfLabel('Baud Rate')
	@GandalfValidator({ notNull: { message: 'Baud Rate is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	baudRateId!: number;

	@GandalfLabel('Disable Preview')
	@GandalfValidator({ notNull: { message: 'Disable Preview is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	disablePreview!: boolean;

	@GandalfLabel('Name')
	@GandalfValidator({ notNull: { message: 'Name is required' } })
	@GandalfValidator({ sizeString: { message: 'Name must be between 1 and 255 characters', minLength: 1, maxLength: 255 } })
	@GandalfProperty({ designType: String, isRequired: true })
	displayName!: string;

	@GandalfLabel('Device')
	@GandalfValidator({ notNull: { message: 'Device is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	practiceLocationSerialDeviceId!: number;

}
